export default "__VITE_ASSET__yvHNhog4__"